export default __webpack_public_path__ + "static/media/enghien15.feb35724.jpg";